export const CHART_STATS_KEY = 'CHART_STATS';
export const SETTINGS_KEY = 'SETTINGS';

import { DEFAULT_SETTINGS } from '@/constants'
class Store {

    settings;

    constructor() {
        const storedSettings = this.getItemOrCreateEmpty(SETTINGS_KEY, DEFAULT_SETTINGS);
        this.settings = {
            ...DEFAULT_SETTINGS,
            ...storedSettings
        }
    }

    setItem(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
        console.debug('setItem', key, JSON.stringify(value));
    }

    getItem(key) {
        try {
            // console.debug('getItem', key, localStorage.getItem(key));
            return JSON.parse(localStorage.getItem(key))
        } catch (e) {
            console.error(e);
        }
        return undefined;
    }

    getItemOrCreateEmpty(key, emptyValue = {}) {
        let item = this.getItem(key);
        if (!item) {
            item = emptyValue;
        }
        this.setItem(key, item);
        return item;
    }

    updateChartStats(chartId, values) {
        let charStats = this.getItemOrCreateEmpty(CHART_STATS_KEY, []);
        let stat = charStats.find(s => s.id === chartId);
        if (typeof values.progress !== 'number' || values.newProgress > values.progress) {
            values.progress = values.newProgress;
        }
        if (!stat) {
            stat = { id: chartId };
            charStats.push(stat);
        }
        Object.assign(stat, values);
        this.setItem(CHART_STATS_KEY, charStats);
    }

    updateSettings(diff) {
        const settings = {
            ...this.settings || {},
            ...diff
        }
        this.settings = settings;
        this.setItem(SETTINGS_KEY, settings);
    }

}

export const store = new Store();